/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSquare } from '../../factoriesAny.js';
export var squareDependencies = {
  typedDependencies,
  createSquare
};